import axios from 'axios';
import { configRefs } from '@utils/config';

async function getFavouritesRequest(portalConfig, user) {
  const endpoint = await configRefs.apis.userdata.get();
  const res = await axios.get(`${endpoint}/api/FavoritesV2?userID=${encodeURIComponent(user.id)}&userInstitutionID=${encodeURIComponent(user.institution?.id ?? "")}&productID=${encodeURIComponent(portalConfig.id)}`);
  return res.data.map(it => ({
    ...it.dynamicContent,
    createdAt: new Date(it.created * 1000),
    id: it.objectID
  }));
}

export { getFavouritesRequest };
//# sourceMappingURL=get-favourties.request.js.map
